export default __webpack_public_path__ + "static/1900_1910-05a9938000cb9859abe61b4fb9f4098d.jpg";